import { DoneButton } from 'common/Prose/Toolbar/MobileWriterToolbar/DoneButton'
import { UndoButton } from 'common/Prose/Toolbar/ToolbarBravo/WriterFormatToolbar/UndoButton'
import { RedoButton } from 'common/Prose/Toolbar/ToolbarBravo/WriterFormatToolbar/RedoButton'
import { observer } from 'mobx-react-lite'
import { AIMenuDrawer } from 'common/Prose/Toolbar/MobileWriterToolbar/AIMenuDrawer'
import { CollaborationDrawerTrigger } from 'blaze-components/MobileWriterTopBar/CollaborationDrawerTrigger'
import { AI } from 'blaze-ui/icons'
import { useRootStore } from 'stores/RootStore'
import Styles from './MobileWriterToolbar.module.scss'
import { TopBarButton } from 'blaze-components/WriterTopBar/TopBarButton'

export const MobileWriterToolbar = observer(() => {
  const drawersStore = useRootStore().drawersStore

  return (
    <div className={Styles.container}>
      <DoneButton />
      <div className={Styles.buttonGroup}>
        <UndoButton />
        <RedoButton />
        <TopBarButton
          icon={() => <AI size={24} />}
          label="AI Actions & Tools"
          onPress={() => drawersStore.openDrawer(AIMenuDrawer)}
        />
        <CollaborationDrawerTrigger />
      </div>
    </div>
  )
})
